import React from 'react';
import tradeUpLogo from 'static/images/logo_tradeup.png';

import './style.scss';

const OpenAddition = () => {
    return (
        <div className="form-group addtion-root">
            <p>
                <b>
                    {__(
                        'TradeUP Securities, Inc. is a broker-dealer registered with SEC and member of FINRA and SIPC.'
                    )}
                </b>
            </p>
            <p>
                <img src={tradeUpLogo} alt="tradeUp" title="tradeUp" height="21px" />
                {__('app is the trading platform.')}
            </p>
        </div>
    );
};

export default OpenAddition;
